<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Set Leave Coordinator</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
              label="Academic Year" outlined rounded persistent-hint hint="Please Select Academic Year"
              multiple></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="employee" :items="instructor_list" item-text="name" item-value="id"
              label="Employee" outlined rounded persistent-hint hint="Please Select Employee" multiple></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete dense required v-model="coordinator" :items="instructor_list" item-text="name"
              item-value="id" label="Coordinator" outlined rounded persistent-hint
              hint="Please Select Coordinator"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" v-if="coordinator && employee.length >0">
            <v-btn @click="saveLeaveCoordinators()" :loading="loader" color="info">save</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="instr_leave_coordinators_list!=''">
        <v-col cols="12">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
        <v-data-table :headers="headers" :items="instr_leave_coordinators_list" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Leave Coordinator List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <v-switch v-model="item.isactive" small color="success" @change="toggleisactive(item)"></v-switch>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      search: "",
      snackbar: false,
      overlay: false,
      title:"",
      description:"",
      headers:[
      { text: "Academic Year", value: "academicyear" },
      { text: "Employee", value: "instructor" },
      { text: "Coordinator", value: "coordinator" },
      { text: "Isactive", value: "isactive" },
      ],
      instr_leave_coordinators_list:[],instructor_list:[],coordinator:"",employee:[],ay_list:[],ay:"",
  }),
   methods: {
     async toggleisactive(item) {
      const formData = {
                    coordinator: item.id,
                    isactive: item.isactive,
                };
      try {
          const res = await axios.post("/LeaveManagement/toggleLeaveCoordinator",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Updated Successfully..."); // show snackbar
            this.course_planner_list=res.data.course_planner_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
        this.course='',this.instructor=[]
      }
     
    },
     async saveLeaveCoordinators() {
     this.loader=true
     const formData = {
                    ay:this.ay,
                    coordinator: this.coordinator,
                    employee: this.employee,
                };
      try {
          const res = await axios.post("/LeaveManagement/saveLeaveCoordinators",formData);
          if (res.data.flag == "YES") {
             this.showSnackbar("green", "Added Successfully..."); // show snackbar
            this.instr_leave_coordinators_list=res.data.instr_leave_coordinators_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.loader = false;
        this.employee=[],this.coordinator=""
      }
     
    },
    async onLoad() {
      try {
          const res = await axios.post("/LeaveManagement/setLeaveCoordinators");
          if (res.data.flag == "Yes") {
            this.instructor_list=res.data.instructor_list
            this.ay_list=res.data.ay_list
            this.ay=res.data.cay
            this.instr_leave_coordinators_list=res.data.instr_leave_coordinators_list
          }
        }
        catch (error) {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        } finally {
        this.save_loader = false;
      }
     
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>